package org.vreo.devicehub.features.core.domain.device.message

import androidx.compose.ui.graphics.ImageBitmap
import kotlinx.datetime.LocalDateTime
import com.benasher44.uuid.uuid4

/**
 * Anpr message.
 */
data class AnprCameraMessage(
    var selected: Boolean = false,                         // Flag indicating if the message is selected
    val id: String = uuid4().toString(),                   // Unique identifier for the message object
    val msgId: String,                                     // Unique identifier for the message in cloud database
    val softwareVersion: String,                           // Software version of the device
    val ocrVersion: String,                                // OCR version used for processing the message
    val vehicleId: Int,                                    // Vehicle identifier
    val licensePlate: String,                              // License plate number
    val licensePlateWidth: Int,                            // Width of the license plate in pixels
    val licensePlateHeight: Int,                           // Height of the license plate in pixels
    val confidenceScore: Float,                            // Confidence score for the license plate
    val ocrAttempt: Int,                                   // Number of OCR attempts
    val imageUrl: String,                                  // URL of the image associated with the message
    val date: LocalDateTime,                               // Date and time of the message
    val timeStamp: Long,                                         // Timestamp of the message
    val telemetry: List<AnprCameraTelemetry> = emptyList(),      // Telemetry readings
    var image: ImageBitmap? = null                               // Anpr captured image
)

/**
 * Anpr camera device telemetry readings
 */
data class AnprCameraTelemetry(
    val date: LocalDateTime,
    val cpuUsage: Float,
    val cpuTemperature: Float,
    val ramUsage: Float,
    val enclosureHumidity: Float,
    val enclosurePressure: Float,
    val enclosureTemperature: Float
)